<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    type?: 'primary' | 'light' | 'white' | 'red'
  }>(),
  {
    type: 'primary',
  }
)
</script>

<template>
  <div
    class="-mx-5 flex min-h-16 items-center justify-center px-5 py-1 text-center text-2xl font-extralight"
    :class="{
      'bg-sky-600 text-white': props.type === 'primary',
      'bg-blue-100 text-sky-600': props.type === 'light',
      'bg-white text-neutral-700': props.type === 'white',
      'bg-red-600 text-white': props.type === 'red',
    }"
  >
    <slot />
  </div>
</template>
